var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverviewLifts(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1 12.128l-1.25-6.13c-.145-.769-.602-1.418-1.25-1.851a2.923 2.923 0 00-2.188-.433L14.234 5.998 13.032 4.17l1.153-1.803 3.99-.817a.493.493 0 00.386-.577.493.493 0 00-.577-.385l-9.52 1.948a.493.493 0 00-.384.577c.048.216.24.384.48.384h.097l4.23-.865-.817 1.274a.52.52 0 000 .529l1.154 1.779L2.84 8.355a2.896 2.896 0 00-2.26 3.437l1.25 6.13a2.928 2.928 0 002.861 2.332c.192 0 .385-.024.577-.048l22.573-4.64a2.938 2.938 0 002.26-3.438h0zM2.766 17.706l-1.25-6.13a1.95 1.95 0 011.515-2.308l22.55-4.616c.12-.024.264-.048.384-.048.385 0 .745.12 1.082.313.432.288.72.721.84 1.226l1.25 6.13a1.95 1.95 0 01-1.514 2.308L5.074 19.196a1.916 1.916 0 01-2.308-1.49z",
    fill: "#000",
    stroke: "#000",
    strokeWidth: 0.391
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewLifts);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "12c7eac8ca237b6bf29fab984b709e35.svg";
export { MemoForwardRef as ReactComponent };